import { IProgression } from 'utility-js-progression';
import { TransferMajorsSelectedQuery } from '../../queries/transfer_majors_selected_query';

export class TransferMajorsOverviewController {
  constructor(
    private ngTransferMajorsSelectedQuery: TransferMajorsSelectedQuery,
    private ngTransferCreditsProgression: IProgression
  ) {}

  hasMajors(): boolean {
    return !_.isEmpty(this.ngTransferMajorsSelectedQuery.result.majors);
  }

  selectionStatus(): string {
    return this.ngTransferCreditsProgression.queryItemByKey('major').status();
  }
}

angular
  .module('capability-ng-transfer')
  .controller('ngTransferMajorsOverviewController', TransferMajorsOverviewController);



// WEBPACK FOOTER //
// ./app/lib/transfer/views/majors_overview/majors_overview.ts